import { useEffect, useState } from 'react';

import { Button } from '@/design-system';

import { updateNoticeCopy } from './copy';

/**
 * "Er staat een nieuwe versie klaar."
 *
 * De service worker installeert een nieuwe versie meteen, maar een open pagina blijft
 * de oude code draaien tot hij herladen wordt. Zonder melding werkt iemand na een
 * deploy dus ongemerkt met de vorige versie door, tot een willekeurige herlaadbeurt.
 * De app herlaadt niet zelf: midden in een formulier of opname zou dat werk kosten.
 * Daarom een rustige balk onderaan met één knop, en de gebruiker kiest het moment.
 *
 * Alleen als er al een service worker de pagina bediende: bij de allereerste
 * installatie is er niets te vernieuwen.
 */
export function UpdateNotice() {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const container = typeof navigator === 'undefined' ? undefined : navigator.serviceWorker;

        if (!container?.controller) {
            return;
        }

        const onChange = () => setReady(true);
        container.addEventListener('controllerchange', onChange);

        return () => container.removeEventListener('controllerchange', onChange);
    }, []);

    if (!ready) {
        return null;
    }

    return (
        <div
            role="status"
            className="fixed inset-x-0 bottom-0 z-[80] flex flex-wrap items-center justify-center gap-3 bg-[var(--ink-900)] px-4 py-3 text-[14px] text-[var(--text-on-dark)]"
        >
            <span>{updateNoticeCopy.text}</span>
            <Button size="sm" onClick={() => window.location.reload()}>
                {updateNoticeCopy.action}
            </Button>
        </div>
    );
}
